import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@clerk/clerk-react";
import { useAuthContext } from "@/contexts/AuthContext";
import type { billing_ExpiringBFListResponse } from "@/api/models/billing_ExpiringBFListResponse";

export const expiringBfKeys = {
  all: ["contracts", "bf-expiring"] as const,
  list: (orgId: string | null | undefined, days: number) =>
    [...expiringBfKeys.all, { orgId: orgId ?? null, days }] as const,
};

/**
 * The dashboard widget's list (#567, #2004, #2007): BF, SBU and KmbB rows of
 * live subsidised versions that expire within `daysAhead` days, expired ones
 * included and sorted first. The server keeps SBU, KmbB and expired rows
 * behind flags for the management app, which predates them.
 */
export function useExpiringBeitragsfaktoren(daysAhead = 90, options?: { enabled?: boolean }) {
  const { isSignedIn, orgId } = useAuth();
  const { isAuthReady } = useAuthContext();
  return useQuery({
    queryKey: expiringBfKeys.list(orgId, daysAhead),
    queryFn: async (): Promise<billing_ExpiringBFListResponse> => {
      const { ContractsService } = await import("@/api");
      const response = await ContractsService.getApiV1ContractsBfExpiring(daysAhead, true, true, true);
      return response as billing_ExpiringBFListResponse;
    },
    enabled: (options?.enabled ?? true) && isSignedIn && isAuthReady && !!orgId,
    staleTime: 5 * 60 * 1000,
  });
}
